import { SousTraitantsDto } from '../../data-access/http/dto/sous-traitants.dto'
import { SousTraitant } from '../../../shared/models/sous-traitant'

export class SousTraitantsMapper {
  static dtoToModel(dto: SousTraitantsDto): SousTraitant {
    return {
      code: dto.code,
      nom: dto.nom,
      siret: dto.siret,
    }
  }

  static dtosToModels(dtos: SousTraitantsDto[]): SousTraitant[] {
    return dtos?.map(SousTraitantsMapper.dtoToModel) ?? []
  }
}
